import React, { useState } from "react";
import styled from "styled-components";

import CardMoreMenu from "../../../common/card-more-menu";
import { StaticAssets } from "../../../styles/custom-assets";
import { theme } from "../../../styles/theme";

type JustificationCardProps = {
  variant?: "attachment" | "spending";
  children?: React.ReactNode;
  isRTL?: boolean;
  onClick?: () => void;
  onDelete?: () => void;
  onOpen?: () => void;
};

export default function JustificationCard(props: JustificationCardProps) {
  const { children, variant = "attachment", isRTL, onClick, onOpen, onDelete } = props;
  const [openMenu, setOpenMenu] = useState(false);

  const handleDelete = () => {
    setOpenMenu(false);
    onDelete?.();
  };

  const handleOpen = () => {
    setOpenMenu(false);
    onOpen?.();
  };

  return (
    <Card onClick={onClick}>
      <JustifiedIcon src={StaticAssets.justified} alt="" />
      {children}
      <CardMoreMenu
        alwaysOpened={false}
        isRTL={isRTL}
        onToggle={() => setOpenMenu(!openMenu)}
        isOpen={openMenu}
        onOpen={onOpen ? handleOpen : undefined}
        onDelete={onDelete ? handleDelete : undefined}
      />
    </Card>
  );
}

/* One row of the list, not a card of its own: the list around them carries the chrome. */
const Card = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  align-self: stretch;
  padding: 14px 20px;
  border-top: 1px solid ${theme.colors.gray[100]};
  background-color: #ffffff;

  &:first-of-type {
    border-top: 0;
  }

  &:hover {
    cursor: pointer;
  }

  &:disabled {
    cursor: auto;
  }
`;

const JustifiedIcon = styled.img`
  width: 20px;
  height: 20px;
  margin-right: 12px;
  flex-shrink: 0;
`;
